import { useQuery } from "@tanstack/react-query";

import { fetchDataGet } from "@/core/api/api-methods";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { merchantEndpoints } from "@/features/merchant/api/endpoints";
import type { MerchantDto } from "@/features/merchant/api/dto";

/** Détail d'un marchand (`GET /Merchants/{id}`). */
export const useMerchant = (merchantId: string, enabled = true) =>
  useQuery({
    queryKey: QUERY_KEYS.MERCHANT_DETAIL(merchantId),
    queryFn: () =>
      fetchDataGet<MerchantDto>({
        url: merchantEndpoints.merchants.detail(merchantId),
      }),
    retry: (failureCount, error) =>
      !/401/.test(error?.message ?? "") && failureCount < 1,
    enabled: enabled && Boolean(merchantId),
  });
